import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-payment-method-list-item-echeck-icon',
    template: `<div class="echeck-label echeck-icon">eCheck</div>`,
    styleUrls: ['./payment-method-list-item-echeck-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodListItemEcheckIconComponent {}
